const ReplaceDate = (props) => {
    return  props === null ? console.log() :
     props.replace('/','-').replace('/','-');
 }
 
 export default ReplaceDate;
 